import Ajax from './Ajax'

const NotificationPreference = {
  getMyPreferences: () => {
    return Ajax.get('/notification-preferences/me')
  },
  updateMyPreferences: (params) => {
    return Ajax.put('/notification-preferences/me', {data: params})
  },
  sendTestEmail: () => {
    return Ajax.post('/notification-preferences/send-test-email', {})
  },
  unsubscribe: (token) => {
    return Ajax.post(`/notification-preferences/unsubscribe/${token}`, {})
  }
}

export default NotificationPreference
